import { formatDistanceToNow } from 'date-fns';

export const formatDateDistanceToNow = (date?: string | null) => {
  if (!date) return date;
  return formatDistanceToNow(date, { addSuffix: true });
};
